import styled from 'styled-components';

export const ThankYouTitle = styled.h1<{ size?: string; color?: string; weight?: string }>`
  font-size: ${(props) => props.size || '1.5rem'};
  color: ${(props) => props.color || '#1a1a1a'};
  font-weight: ${(props) => props.weight || '600'};
  margin-bottom: 0.5rem;
  font-family: 'Inter', sans-serif;

  @media (max-width: 768px) {
    font-size: ${(props) => {
  const baseSize = props.size || '1.5rem';
  return `calc(${baseSize} * 0.9)`;
}};
  }
`;